/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Resource and Data Exchange
 * Private Data Enclave API
 * OpenAPI spec version: 0.1.0
 */

export type ProjectRoleID = (typeof ProjectRoleID)[keyof typeof ProjectRoleID];

export const ProjectRoleID = {
  OWNER: 'owner',
  COLLABORATOR: 'collaborator',
} as const;
